import React, { type ReactNode } from 'react'
import VoteIoEmptyIcon from '../svgr/VoteIoEmpty'
import { styled } from '@linaria/react'
import { Typography } from '../ui/Typography'
import { colors } from '../styles/colors'
import { FormattedMessage } from 'react-intl'
import { ButtonRegular } from '../ui/Button'
import { useNavigate } from 'react-router'
import { indexPagePath } from '../pages/IndexPage'

interface EmptyListProps {
  navigateTo?: string
  buttonContent?: ReactNode
}

export const EmptyList = ({
  navigateTo = indexPagePath,
  buttonContent = (
    <FormattedMessage id="create-poll" defaultMessage="К боксам" />
  ),
}: EmptyListProps) => {
  const navigate = useNavigate()

  return (
    <EmptyContainer>
      <VoteIoEmptyIcon />

      <Typography fontWeight={700} fontSize={13} color={colors.grey900}>
        <FormattedMessage id="empty-list" defaultMessage="Список пуст" />
      </Typography>

      <StyledButton
        backgroundColor={colors.secondary}
        textColor={colors.white}
        onClick={async () => await navigate(navigateTo)}
      >
        {buttonContent}
      </StyledButton>
    </EmptyContainer>
  )
}

const EmptyContainer = styled.div`
  display: grid;
  gap: 24px;
  align-items: center;
  align-content: center;
  justify-content: center;
  justify-items: center;
  height: 100%;
`

const StyledButton = styled(ButtonRegular)`
  min-width: 120px;
`
